import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    trialId: null,
    isLoadingImages: true,
    isLoadingData: true,
    trialDataLoaded: false,
    totalImages: 0,
    loadedImagesCount: 0,
    selectedLanguage: 'ES',
    cookiesAccepted: null,
    utmParams: {
      utm_source: '',
      utm_medium: '',
      utm_campaign: '',
      utm_content: '',
      utm_term: '',
    },
    provisionalUserId: null,
  },
  mutations: {
    setTrialId(state, trialId) {
      state.trialId = trialId;
    },
    setTotalImages(state, totalImages) {
      state.totalImages = totalImages;
    },
    incrementLoadedImagesCount(state) {
      state.loadedImagesCount += 1;
      if (state.loadedImagesCount === state.totalImages) {
        state.isLoadingImages = false;
      }
    },
    trialDataLoaded(state) {
      state.trialDataLoaded = true;
      if (state.trialDataLoaded) {
        state.isLoadingData = false;
      }
    },
    setSelectedLanguage(state, language) {
      state.selectedLanguage = language;
    },
    setCookiesAccepted(state, value) {
      state.cookiesAccepted = value;
    },
    setUtmParams(state, utmParams) {
      state.utmParams = utmParams;
    },
    setProvisionalUserId(state, id) {
      state.provisionalUserId = id;
    },
    clearProvisionalUserData(state) {
      state.provisionalUserId = null;
    },
  },
  actions: {
    setTrialId({ commit }, trialId) {
      commit('setTrialId', trialId);
    },
    setTotalImages({ commit }, totalImages) {
      commit('setTotalImages', totalImages);
    },
    incrementLoadedImagesCount({ commit }) {
      commit('incrementLoadedImagesCount');
    },
    trialDataLoaded({ commit }) {
      commit('trialDataLoaded');
    },
    setSelectedLanguage({ commit }, language) {
      commit('setSelectedLanguage', language);
    },
    setCookiesAccepted({ commit }, value) {
      commit('setCookiesAccepted', value);
    },
    setUtmParams({ commit }, utmParams) {
      commit('setUtmParams', utmParams);
    },
    setProvisionalUserId({ commit }, id) {
      commit('setProvisionalUserId', id);
    },
    clearProvisionalUserData({ commit }) {
      commit('clearProvisionalUserData');
    },
  },
  getters: {
    isLoading: (state) => state.isLoading,
    selectedLanguage: (state) => state.selectedLanguage,
    cookiesAccepted: (state) => state.cookiesAccepted,
    provisionalUserId: (state) => state.provisionalUserId,
  },
});
